<template>
  <div>
    <el-select
      :placeholder="$t('Seçin')"
      filterable
      :value="selected"
      @input="handleInput"
      style="width: 100%"
    >
      <el-option
        v-for="item in filteredData"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { GetDamageCategories } from "../../services/cls";
export default {
  props: {
    value: [Number, String],
    damageType: Number
  },
  data() {
    return {
      data: [],
      selected: this.value,
      damageTypeVal :this.damageType
    };
  },

  methods: {
    handleInput(e) {
      this.$emit("input", e);
      this.selected = e;
    },

    getData() {
      GetDamageCategories().then((response) => {
        if (response.data.data) {
          this.data = response.data.data;
        } else {
          this.$message({
            type: "error",
            message: "Damage Category: No data found!",
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
  computed: {
  filteredData() {
    if(this.damageTypeVal === 1) {
      return this.data.filter(item => item.id === 1);
    } else if(this.damageTypeVal === 2) {
      return this.data.filter(item => item.id === 2);
    } else if(this.damageTypeVal === 3) {
      return this.data.filter(item => item.id !== 1 && item.id !== 2);
    } else if(this.damageTypeVal === 0 || !this.damageTypeVal ) {
      return this.data; 
    }
    return [];
  }
}
,
  watch: {
    value() {
      this.selected = this.value;
    },
    damageType() {
      this.damageTypeVal = this.damageType;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>